import { differenceInMinutes } from 'date-fns';

import { OrderSummary } from '@lib/types';
import { firebase } from '@lib/firebase';

export function isOrderLate(order: OrderSummary) {
  const HANDLING_TIME: number = firebase.getRemoteConfigNumber('HANDLING_TIME');

  // only apply the "isLate" logic to the following statuses
  if (!['PENDING', 'ROUTED', 'SEEN'].includes(order.state)) {
    return false;
  }

  // check if the order is not SEEN within expectedWaitingTime
  if (['PENDING', 'ROUTED'].includes(order.state)) {
    return (
      differenceInMinutes(new Date(), order.createdAt) > (HANDLING_TIME ?? 0)
    );
  }

  // if order SEEN, check if it's accepted/rejected within expectedHandlingTime
  if (order.state === 'SEEN' && order.seenAt) {
    return differenceInMinutes(new Date(), order.seenAt) > (HANDLING_TIME ?? 0);
  }

  return false;
}
